import { createApp } from 'vue'
import BooklistReviewsIsland from '../booklist-reviews/BooklistReviewsIsland.vue'

export const BOOK_REVIEWS_ISLAND_ID = 'book-reviews-mount'

/**
 * 书籍详情评论岛屿。挂在既有 #book-reviews-mount，与书名/简介节点分离。
 * 复用书单评论组件，API 走 /api/v1/bookhub/books/:id/reviews。
 */
export function mountBookReviewsIsland() {
  const el = document.getElementById(BOOK_REVIEWS_ISLAND_ID)
  if (!el || el.dataset.islandMounted === 'true') return
  const targetId = (el.dataset.bookId || '').trim()
  if (!targetId) {
    console.error('[book-reviews] missing data-book-id')
    return
  }
  el.dataset.islandMounted = 'true'
  // 清掉 SSR 占位，由岛屿渲染输入框与列表
  el.innerHTML = ''
  createApp(BooklistReviewsIsland, { target: 'book', targetId }).mount(el)
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBookReviewsIsland)
  } else {
    mountBookReviewsIsland()
  }
}
